import { fluentValidator, ValidationResult } from "sprint-common-web";

import { ContentAssociationAncillaryDetails } from "../types/ContentAssociationDetails";

export const createContentAssociationAncillaryItemValidator = () => {
    const validateAncillary = (content: ContentAssociationAncillaryDetails): ValidationResult => {
        return fluentValidator<ContentAssociationAncillaryDetails>()
            .when((ancillary) => !!ancillary.buzz?.isArchived)
            .addWarning("Ancillary is archived in Buzz")
            .when((ancillary) => !!ancillary.buzz?.isDeleted)
            .addWarning("Ancillary is deleted in Buzz")
            .validate(content);
    };

    return {
        validateAncillary
    };
};
